export default __webpack_public_path__ + "static/media/hac2020landing.85dc731d.PNG";